import {
    ChoirRehearsal,
    ChoirRehearsalSong,
    RehearsalDryRunAudio,
    RehearsalSetlistResource,
} from './types';

const parseArray = <T>(value: unknown): T[] => {
    if (Array.isArray(value)) return value as T[];
    if (typeof value !== 'string' || !value.trim()) return [];

    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed as T[] : [];
    } catch {
        return [];
    }
};

const parseOneOrArray = <T>(value: unknown): T[] => {
    if (Array.isArray(value)) return value as T[];
    if (value && typeof value === 'object') return [value as T];
    if (typeof value !== 'string' || !value.trim()) return [];

    try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) return parsed as T[];
        return parsed && typeof parsed === 'object' ? [parsed as T] : [];
    } catch {
        return [];
    }
};

export const rehearsalDryRunAudioId = (audio: Partial<RehearsalDryRunAudio>, index = 0): string => String(
    audio.uuid || audio.cid || `dry-run-${index}`
);

export const rehearsalRootSetlistResources = (
    resources: RehearsalSetlistResource[] = [],
): RehearsalSetlistResource[] => [
    ...resources.filter((resource) => (
        resource.resource_scope === 'rehearsal' &&
        resource.rehearsal_role === 'arrangement_stem'
    )),
    ...resources.filter((resource) => (
        resource.resource_scope == null ||
        (
            resource.resource_scope === 'rehearsal' &&
            resource.rehearsal_role !== 'arrangement_stem'
        )
    )),
];

export const normalizeChoirRehearsal = (value: any): ChoirRehearsal => {
    const songs = parseArray<ChoirRehearsalSong>(value?.song_list);
    const pluralDryRuns = parseArray<RehearsalDryRunAudio>(value?.dry_run_audios);
    const legacyDryRuns = pluralDryRuns.length
        ? pluralDryRuns
        : parseOneOrArray<RehearsalDryRunAudio>(value?.dry_run_audio);
    const dryRunAudios = legacyDryRuns.map((audio: RehearsalDryRunAudio, index: number) => ({
        ...audio,
        uuid: rehearsalDryRunAudioId(audio, index),
    }));

    return {
        ...value,
        song_list: songs,
        learning_materials: parseArray(value?.learning_materials),
        source_setlists: parseArray(value?.source_setlists),
        setlist_resources: parseArray(value?.setlist_resources),
        harmony_selections: parseArray(value?.harmony_selections),
        dry_run_audio: dryRunAudios[0] || null,
        dry_run_audios: dryRunAudios,
    } as ChoirRehearsal;
};
